import React from "react"

import { DefaultPlayer as Video } from "react-html5video"
import "react-html5video/dist/styles.css"

const VideoPlayer = ({ src, style }) => {
  // Check if we're on the server side.
  // This is because otherwise accessing things like navigator or window may break the app when the app has server side rendering.
  if (!(typeof window !== "undefined" && window !== null)) {
    return null
  }

  return (
    <Video
      controls={["PlayPause", "Seek", "Time", "Volume", "Fullscreen"]}
      style={style}
    >
      <source src={src} type="video/mp4" />
    </Video>
  )
}

export default VideoPlayer
